import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgPhone = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="m20.456 16.505-2.812-2.18a1.173 1.173 0 0 0-1.561.104l-1.178 1.178c-1.384-.162-2.783-.869-3.872-1.958-1.09-1.09-1.797-2.489-1.959-3.873l1.178-1.178c.412-.412.457-1.09.103-1.56L8.161 4.21a1.207 1.207 0 0 0-.854-.456 1.184 1.184 0 0 0-.912.339L5.217 5.3c-.957.957-1.046 2.606-.236 4.638.736 1.885 2.15 3.931 3.99 5.772 1.84 1.84 3.887 3.254 5.772 3.99 2.047.795 3.696.707 4.638-.235l1.193-1.193c.235-.236.368-.574.338-.913a1.207 1.207 0 0 0-.456-.854ZM7.705 4.579l2.18 2.812a.602.602 0 0 1-.045.78l-.044.044-2.916-3.74a.588.588 0 0 1 .825.104Zm11.249 14.459c-1.605 1.604-5.904-.074-9.585-3.755-3.681-3.681-5.36-7.966-3.755-9.585l.825-.825 2.915 3.755-.883.898c.103 1.56.839 3.195 2.15 4.505 1.31 1.31 2.944 2.047 4.505 2.15l.898-.898 3.755 2.915-.825.84Zm1.237-1.252-3.74-2.915.044-.045a.586.586 0 0 1 .78-.044l2.813 2.18a.588.588 0 0 1 .103.824Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgPhone;
